import { Promise } from 'core-js'
import Vue from 'vue'

import _ from "lodash";

import Group from './services/group'

const store = new Vue.observable({
  ready: false,
  group: {},
  assignments: {},
  recent: [],
  invite: {}
})

let AuthSync;
const GroupCollection = {
  use: ({ authSync }) => {
    AuthSync = authSync;
    console.log("GroupCollection Use:",AuthSync);
  },
  isReady: () => store.ready,
  initialised: async () => {
    while (!store.ready) {
      await new Promise(resolve => setTimeout(resolve, 300))
    }
    return
  },
  reset: () => {
    store.ready = false
    store.group = {}
    store.invite = {}
    store.recent = []
  },
  init: async () => {
    GroupCollection.reset()

    await Group.clear()
    await new Promise((resolve) => setTimeout(resolve,1000))
    let groups = await Group.list({ ignoreCache: true, params: { simple: true } }).then(({ data }) => data)
    let invites = await Group.listAllInvites({ignoreCache: true}).then(({data}) => data);

    //set invites details
    let inviteStore = {}
    invites.forEach(invite => {
      inviteStore[invite._id] = invite
    })

    //set group details
    let groupStore = {}
    groups.forEach(group => {
      groupStore[group._id] = group
    })

    Vue.set(store, 'invite', inviteStore);
    Vue.set(store, 'group', groupStore);

    try {
      var recentGroups = JSON.parse(window.localStorage['recentGroups']);
      Vue.set(store, 'recent', recentGroups);
    } catch (error) {
      console.log("recent groups parse error", error);
      Vue.set(store, 'recent', []);
    }

    console.log("GroupCollection", store);

    store.ready = true
  },
  refresh: () => {
    if (!store.ready) return
    console.log("can refresh")
    GroupCollection.init()
  },
  authSync: AuthSync || function() {},

  get: (id) => store.group[id],
  getDetails: async (id) => {
    let group = await Group.get(id, {ignoreCache: true}).then(({data}) => data);
    if(group?._id) Vue.set(store.group, group._id, group);
    return group;
  },
  getAssignments: async (id) => {
    const assignments = await Group.getAssignments(id, {ignoreCache: true}).then(({data}) => data);
    Vue.set(store.assignments, id, assignments);
    return assignments;
  },
  getAll: () => store.group,
  list: (options) => {
    let groups = []
    for (const [key, value] of Object.entries(store.group)) {
      if (!value.data || !value.data.archived) groups.push(store.group[key])
    }

    if(options && options.orderBy) return _.orderBy(groups, options.orderBy);
    return groups
  },
  addToRecents: (id) => {
    let group = GroupCollection.get(id);
    if(!id || !group) return;

    // add to recents
    const index = store.recent.indexOf(group._id);
    if(index > -1) store.recent.splice(index, 1);
    store.recent.unshift(group._id);
    if(store.recent.length > 5) store.recent.pop();
    window.localStorage['recentGroups'] = JSON.stringify(store.recent);
  },
  listRecent: () => {
    return store.recent.filter(id => store.group[id]).map(id => GroupCollection.get(id));
    // return GroupCollection.list(options).filter(({_id}) => store.recent.includes(_id));
  },
  getAvatarURL(id) {
    return Vue.prototype.$hub.avatarURL(id,'group');
  },

  removeDetails(group) {
    if(!group) return;
    Vue.delete(store.group, group._id || group);
  },

  getUser: (id, userId) => {
    let group = GroupCollection.get(id);
    if(!group || !group.assignments) return null;
    let user = null;
    group.assignments.forEach(({users}) => {
      if(!user) user = users.find(({_id}) => _id === userId);
    });
    return user;
  },
  getUserDetails: async (id, userId) => {
    let group = GroupCollection.get(id);
    if(!group || !group.assignments) return null;

    let hasUser = null;
    group.assignments.forEach(({users}) => {
      if(!hasUser) hasUser = users.find(({_id}) => _id === userId);
    });

    if(!hasUser) return null;

    let user = await Group.getUser(id, userId, {ignoreCache: true}).then(({data}) => data);
    if(user?._id) {
      (store.group[id].assignments || []).forEach(({users}, index) => {
        let userIndex = users.findIndex(({_id}) => _id === userId);
        if(userIndex > -1) {
          let usersArray = store.group[id].assignments[index].users;
          usersArray[userIndex] = {...user};
          Vue.set(store.group[id].assignments[index], 'users', usersArray);
        }
      });
    }

    return user;
  },
  getUserRole: (groupId, userId) => {
    let group = GroupCollection.get(groupId?._id || groupId);
    if(!group || !group.assignments) throw new Error("no user role found");
    const assignment = group.assignments.find(({users}) => (users.map(({_id}) => _id)).includes(userId?._id || userId));
    if(!assignment) throw new Error("no user role found");
    return assignment.role._id;
  },
  updateUser: (user) => {
    const userId = user?._id;

    console.log("updateUser", user);

    Object.keys(store.group).forEach(groupId => {
      (store.group[groupId].assignments || []).forEach(({users}, index) => {
        let userIndex = users.findIndex(({_id}) => _id === userId);
        if(userIndex > -1) {
          let usersArray = store.group[groupId].assignments[index].users;
          usersArray[userIndex] = {...user};
          Vue.set(store.group[groupId].assignments[index], 'users', usersArray);
        }
      });
    });
  },
  updateUserDetails: (userId, details) => {
    console.log("updateUserDetails", userId, details);

    Object.keys(store.group).forEach(groupId => {
      (store.group[groupId].assignments || []).forEach(({users}, index) => {
        let userIndex = users.findIndex(({_id}) => _id === userId);
        if(userIndex > -1) {
          let usersArray = store.group[groupId].assignments[index].users;
          usersArray[userIndex] = {...(usersArray[userIndex] || {}), ...details};
          Vue.set(store.group[groupId].assignments[index], 'users', usersArray);
        }
      });
    });
  },

  create: async (payload) => {
    let group = await Group.create(payload).then(({data}) => data);
    Vue.set(store.group, group._id, group);
    await AuthSync(true);
    return group;
  },

  update: async (groupId, payload) => {
    let group = GroupCollection.get(groupId);
    if(!group) throw new Error("group not found");
    let groupRes = await Group.update(groupId, payload).then(({data}) => data);
    Vue.set(store.group, groupRes._id, groupRes);
    return groupRes;
  },

  remove: async (groupId, payload) => {
    // let group = GroupCollection.get(groupId);
    // if(!group) throw new Error("group not found");
    let groupRes = await Group.delete(groupId, payload).then(({data}) => data);
    GroupCollection.removeDetails({_id: groupId});
    await AuthSync(true);
    return groupRes;
  },

  check: async () => {
    const checkRes = await Group.check({ignoreCache: true}).then(({data}) => data.data);
    checkRes.forEach(group => {
      GroupCollection.removeDetails(group);
    });
    
    return checkRes;
  },

  archive: async (groupId) => {
    let groupRes = await Group.archive(groupId?._id || groupId).then(({data}) => data);
    // GroupCollection.removeDetails(groupRes);
    // await AuthSync(true);
    return groupRes;
  },

  unarchive: async (groupId) => {
    let groupRes = await Group.unarchive(groupId?._id || groupId).then(({data}) => data);
    // GroupCollection.removeDetails(groupRes);
    // await AuthSync(true);
    return groupRes;
  },

  generateAccessCode: async () => {
    let accessCode = await Group.generateAccessCode({ignoreCache: true}).then(({data}) => data.accessCode);
    return accessCode;
  },

  joinDetails: async ({groupId, code} = {}) => {
    let group = groupId ? await Group.joinIdDetails(groupId).then(({data}) => data) : Group.joinCodeDetails(code).then(({data}) => data);
    return group;
  },
  joinCode: async (code) => {
    let group = await Group.joinCode(code).then(({data}) => data);
    Vue.set(store.group, group._id, group);

    if(group.parentGroupId) {
      let groupParents = await Group.listParents(group._id, { ignoreCache: true, params: {  } }).then(({ data }) => data)
      groupParents.forEach(group => {
        Vue.set(store.group, group._id, group);
      })
    }

    await AuthSync(true);
    return group;
  },
  joinId: async (groupId) => {
    let group = await Group.joinId(groupId).then(({data}) => data);
    Vue.set(store.group, group._id, group);

    if(group.parentGroupId) {
      let groupParents = await Group.listParents(group._id, { ignoreCache: true, params: {  } }).then(({ data }) => data)
      groupParents.forEach(group => {
        Vue.set(store.group, group._id, group);
      })
    }

    await AuthSync(true);
    return group;
  },

  leave: async (groupId) => {
    let group = GroupCollection.get(groupId);
    if(!group) throw new Error("group not found");

    let groupLeave = await Group.leave(groupId).then(({data}) => data);
    if(groupLeave !== "OK") throw new Error("could not leave group");
    Vue.delete(store.group, group._id);
    await AuthSync(true);
  },

  assignUser: async (groupId, userId, roleId) => {
    let group = GroupCollection.get(groupId);
    if(!group) throw new Error("group not found");
    
    let user = GroupCollection.getUser(groupId, userId);
    if(!user) throw new Error("user not in group");

    let groupAssign = await Group.assign(groupId, {
      user: userId,
      role: roleId
    }).then(({data}) => data);
    if(groupAssign !== "OK") throw new Error("user could not be assigned role");

    let groupRes = await GroupCollection.getDetails(groupId);
    if(!groupRes) throw new Error("group not found");

    Vue.set(store.group, groupRes._id, groupRes);
  },
  unassignUser: async (groupId, userId) => {
    let group = GroupCollection.get(groupId);
    if(!group) throw new Error("group not found");
    
    let user = GroupCollection.getUser(groupId, userId);
    if(!user) throw new Error("user not in group");

    let groupUnassign = await Group.unassign(groupId, {
      user: userId
    }).then(({data}) => data);
    if(groupUnassign !== "OK") throw new Error("user could not be unassigned role");

    let groupRes = await GroupCollection.getDetails(groupId);
    if(!groupRes) throw new Error("group not found");

    Vue.set(store.group, groupRes._id, groupRes);
  },
  invite: async (group, emails = [], role) => {
    // let group = GroupCollection.get(groupId._id || groupId);
    // if(!group) throw new Error("group not found");
    
    const inviteRes = await Group.invite(group._id || group, { role: role._id || role, emails }).then(({data}) => data);
    return inviteRes;
  },
  refreshInvites: async () => {
    let invites = await Group.listAllInvites({ignoreCache: true}).then(({data}) => data);

    //set invites details
    let inviteStore = {}
    invites.forEach(invite => {
      inviteStore[invite._id] = invite
    })

    Vue.set(store, 'invite', inviteStore);
  },
  listInvites: (options) => {
    let invites = []
    for (const [key, value] of Object.entries(store.invite)) {
      if (!value.data || !value.data.archived) invites.push(store.invite[key])
    }

    if(options && options.orderBy) return _.orderBy(invites, options.orderBy);
    return invites
  },
  acceptInvite: async (invite) => {
    const inviteId = invite?._id || invite;
    const inviteRes = await Group.getInvite(null, inviteId).then(({data}) => data);
    let group = inviteRes.group;

    await Group.acceptInvite(inviteId).then(({data}) => data);
    Vue.delete(store.invite, inviteId);
    Vue.set(store.group, group?._id, group);

    if(group.parentGroupId) {
      let groupParents = await Group.listParents(group._id, { ignoreCache: true, params: {  } }).then(({ data }) => data)
      groupParents.forEach(group => {
        Vue.set(store.group, group._id, group);
      })
    }

    await AuthSync(true);
    return inviteRes;
  },
  declineInvite: async (invite) => {
    const inviteId = invite?._id || invite;
    const inviteRes = await Group.getInvite(null, inviteId).then(({data}) => data);

    await Group.declineInvite(inviteId).then(({data}) => data);
    Vue.delete(store.invite, inviteId);

    await AuthSync(true);
    return inviteRes;
  },
}

export default GroupCollection